import React from 'react';
const AdminUsers = () => <div className="min-h-screen p-8">Admin Users Management</div>;
export default AdminUsers; 